<template>
  <div class="landing-container">
    <div class="hero-section">
      <img
        src="/images/gp_landing_banner.png"
        alt="banner"
        class="banner-image"
      />

      <div class="progress-container">
        <img src="/images/progress.gif" alt="progress" class="progress-image" />
      </div>
    </div>

    <div class="content-wrapper">
      <div class="lp-register">
        <form action="#" @submit.prevent="addsubscription" class="lp-form">
          <div id="errorMessage" class="error-message">{{ errorMessage }}</div>

          <label>Enter Your Phone Number</label>
          <div class="phone-number">
            <input
              type="text"
              v-model="phone"
              placeholder="Mobile Number"
              class="phone-input"
            />
          </div>

          <button
            type="submit"
            class="submit-phone-btn"
            @click="addsubscription"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? "Processing..." : "Continue" }}
          </button>
        </form>
      </div>

      <div class="gaming-content">
        <img
          src="/images/gaming-icon.svg"
          alt="Gaming Icon"
          class="gaming-icon"
        />
        <p class="gaming-text">Your gaming content is ready!</p>
      </div>

      <div class="footer-text">
        <p>
          XoshPlay is Bangladesh's ultimate mobile gaming portal, giving you
          instant access to hundreds of exciting games—from action and puzzles
          to racing and strategy—right from your phone with no downloads
          required. Enjoy unlimited gaming every day for just 5 BDT + VAT via
          SMS. This service is for users 18+ (or with billpayer permission) and
          is provided by XoshPlay.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LandingGP",
  data() {
    return {
      phone: "",
      errorMessage: "",
      isValidPhone: false,
      host: null,
      isSubmitting: false
    };
  },
  created() {
    this.$root.mainWrapper = "wrapper-main-landingpage";
  },
  mounted() {
    document.body.style.backgroundColor = "#ffffff";
  },
  beforeDestroy() {
    document.body.style.backgroundColor = "";
  },
  methods: {
    validatePhone() {
      const phone = this.phone ? this.phone.trim() : "";
      const regex = /^(88017|88013|017|013)\d{8}$/;

      this.isValidPhone = regex.test(phone);

      if (!this.isValidPhone) {
        this.errorMessage =
          phone.length > 0
            ? "Please enter a valid Grameenphone number."
            : "Phone number cannot be empty.";
      } else {
        this.errorMessage = "";
      }
    },
    addsubscription() {
      this.validatePhone();

      if (!this.isValidPhone) return;

      this.isSubmitting = true;

      this.host = this.$root.url();
      const phone = this.phone.trim();
      const path = "gpCharge";
      const url = `${this.host}/${path}?msisdn=${phone}&packageId=1`;

      axios
        .get(url)
        .then(response => {
          if (response.data.status_code === 200) {
            window.location.href = response.data.redirect_url;
          } else {
            this.errorMessage = response.data.message || "An error occurred";
            this.isSubmitting = false;
          }
        })
        .catch(() => {
          this.errorMessage = "Something went wrong. Please try again.";
          this.isSubmitting = false;
        });
    }
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: Arial, sans-serif;
  line-height: 1.6;
}

.landing-container {
  background-color: #fcfbfc;
}

.hero-section {
  position: relative;
  width: 100%;
  text-align: center;
}

.progress-container {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.banner-image {
  max-width: 560px;
  width: 100%;
  height: auto;
  max-width: 100%;
}

.progress-image {
  width: 160px;
  height: auto;
  max-width: 100%;
}

.content-wrapper {
  padding: 20px;
}

.lp-register {
  padding: 16px;
  border: 2px solid #53b5aa4d;
  border-radius: 16px;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 4px 4px 0px #0e691f40;
  text-align: center;
}

.lp-form label {
  font-family: "Poppins", sans-serif;
  color: #1d1d1d;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
}

.phone-number {
  width: 100%;
  margin: 15px 0;
}

.phone-input {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #53b5aa;
  border-radius: 16px;
  font-size: 16px;
  color: #333;
  background: #ffffff;
  outline: none;
}

.phone-input:focus {
  border-color: #2eb9a9;
}

.error-message {
  color: red;
  margin-bottom: 15px;
  font-size: 14px;
  text-align: center;
  min-height: 18px;
}

.submit-phone-btn {
  background: url("/images/gp_langing_button.gif") no-repeat center center;
  background-size: cover;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  padding: 16px;
  border-radius: 50px;
  border: none;
  width: 100%;
  max-width: 300px;
  cursor: pointer;
  transition: transform 0.2s;
}

.submit-phone-btn:hover {
  transform: scale(1.02);
}

.submit-phone-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.gaming-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 50px 0;
  width: 100%;
}

.gaming-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 15px;
}

.gaming-text {
  color: #888888;
  font-size: 16px;
  text-align: center;
  max-width: 400px;
}

.footer-text {
  width: 100%;
  max-width: 600px;
  padding: 0 20px;
  margin: 60px 0;
}

.footer-text p {
  color: #888888;
  font-size: 14px;
  text-align: center;
  line-height: 1.6;
}
</style>
